<template>
  <section class="content">
    <h2 class="subtitle">
      Digital Signature and Confirmation
    </h2>
    <p>By selecting "yes" below, I affirm that:</p>
    <ul>
      <li>I have voted for at least 10 categories in this ballot.</li>
      <li>This is my first and only ballot.</li>
      <li>I have followed the rules for submission.</li>
    </ul>
    <label class="checkbox">
        <input type="checkbox" name="affirmation" required>
        I Affirm
    </label>
  </section>
</template>

<script>
export default {
  //
};
</script>
